import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { PaymentElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import Label from '@/components/form/Label/Label';

const CheckoutForm = (props) => {
  const { errorMessage, isLoadingCheckout, submitPaymentForm, lenguageData } = props;
  const stripe = useStripe();
  const elements = useElements();

  return (
    <form onSubmit={(event) => submitPaymentForm(event, stripe, elements)}>
      <PaymentElement />
      {!isLoadingCheckout && (
        <button
          type="submit"
          className={
            'bgPink1 width100 border-rad24px borderGray050 fontWhite grayShadow16 margtb30 padlr40 padtb10 text-18'
          }
          disabled={!stripe || !elements}
        >
          <strong>{lenguageData === 'EN' ? 'Pay' : 'Pagar'}</strong>
        </button>
      )}
      {isLoadingCheckout && <Label className={'margtb10'}>{lenguageData === 'EN' ? 'Loading...' : 'Cargando...'}</Label>}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

const PaymentFormView = (props) => {
  const {
    stripePromise,
    getSripeOptions,
    getTotalPrice,
    errorMessage,
    isLoadingCheckout,
    submitPaymentForm,
    spaceDetail,
  } = props;
  const lenguageData = useSelector((state) => state.lenguage.lang);
  const amount = getTotalPrice().toFixed(2);
  const stripeOptions = getSripeOptions(parseFloat(amount));
  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <FlexContainer className="padtb10 bgGray025 margt6" />
      <Label className={'margt10 text-16 m-text-12'}>
        {lenguageData === 'EN' ? 'Total amount to pay' : 'Precio total a pagar:'}{' '}
        <span className={'bold'}>${amount + ' ' + spaceDetail?.currency}</span>
      </Label>
      <CheckoutForm
        lenguageData={lenguageData}
        errorMessage={errorMessage}
        isLoadingCheckout={isLoadingCheckout}
        submitPaymentForm={submitPaymentForm}
      />
    </Elements>
  );
};

export default PaymentFormView;
